import { render, staticRenderFns } from "./BookingPaymentLink.vue?vue&type=template&id=3fa9ce94&"
import script from "./BookingPaymentLink.vue?vue&type=script&lang=js&"
export * from "./BookingPaymentLink.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports